import { Link } from "react-router-dom";
import '../index.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

export default function ContentCard({ item }) {
  const link = `/content/${item.public_id}`;
  if(item.type === "project"){
    return null;
  }
  return (
    <Link to={link} className="col-md-4 wow slideInUp text-decoration-none text-reset">
      <div className="blog-item rounded overflow-hidden">
        <div className="blog-img position-relative overflow-hidden">
          <img
            src={`https://node.lcwe-lb.com/uploads/images/${item.image}`}
            alt={item.title}
            loading="lazy"
          />
          <a className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4">
            {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
          </a>
        </div>
        <div className="p-2">
          <div className="d-flex">
            <small>
              
              {item.date && (
                <p className="date">
                  <i className="bi bi-calendar-event text-primary me-2"></i> {new Date(item.date).toLocaleDateString()}
                </p>
              )}
            </small>
          </div>
          <h4 className="mb-3" >{item.title}</h4>
        </div>
      </div>
    </Link>
    );
}
